import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {computed, onMounted, ref} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollText',
  props: {
  text: {
    type: String,
    required: true,
  },
  disable: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const container = ref(null as HTMLDivElement | null);
const inner = ref(null as HTMLDivElement | null);

const checkOverflow = () => {
  if (container.value && inner.value) {
    const containerWidth = container.value.offsetWidth;
    const textWidth = inner.value.offsetWidth;
    const scrollWidth = `${containerWidth - textWidth}px`;
    inner.value.style.setProperty('--scroll-width', scrollWidth);
  }
};

onMounted(() => {
  checkOverflow();
});

const textShouldScroll = computed(() => {
  return !props.disable && container.value && inner.value && inner.value.offsetWidth > container.value.offsetWidth;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "container",
    ref: container,
    class: "container"
  }, [
    _createElementVNode("span", {
      ref_key: "inner",
      ref: inner,
      class: _normalizeClass({'scrolling-text': textShouldScroll.value})
    }, _toDisplayString(__props.text), 3)
  ], 512))
}
}

})